<script lang="ts">
  import type { ImageDetails } from 'proto/image';
	
	import { toSrc, type MaybeImageDetails } from '$lib/serv/image-details';
	import { onMount } from 'svelte';
	import { observeOnceOff } from '$lib/serv/dom';

	export let image: Parameters<typeof toSrc> | ImageDetails | string | undefined;
	export let alt: string;

	$: src = Array.isArray(image) ? toSrc(...image) : toSrc(image);

	let img: any;
	let container: HTMLDivElement;

	let imageLoaded: boolean = false;
	let loadedSrc: string;

	onMount(() => {
		img.onload = () => {
			imageLoaded = true;
		}
		observeOnceOff(container, (elm) => {
			if (src) loadedSrc = src; // TODO: what to show if src is empty?
		});
	});
</script>

<img bind:this={img} src={loadedSrc} {alt}>

<div class="image" bind:this={container}>
	<div class="imgInner" class:loaded={imageLoaded} style={imageLoaded ? `background-image: url('${src}')` : null}></div>
	<slot></slot>
</div>


<style lang="scss">
	@use 'color';

	img { display: none; }

	.image { position: relative; }

	.imgInner {
		position: absolute;
		inset: 0;
		opacity: 0;
		transition-duration: 300ms;
		transition-property: opacity;
		transition-timing-function: ease-out;
		padding: 16px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		
		&.loaded { opacity: 1; }
	}
</style>